import React, { useContext } from 'react'
import { User } from 'types/user';

export type UserContextProps = {
    user: User | undefined;
    isValid: boolean;
    displayName: string;
    userId: string;
    isLegacy: boolean;
    clubTag: string;
}

export type UserContextType = UserContextProps 

export const UserContext = React.createContext<UserContextProps | undefined>(
  undefined
)

export const useUser = (): UserContextProps => {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider')
    }
    return context
}
